/**
  异步加载js,支持数组和单个js
  asyncLoadJS(['a.js', 'b.js']).then(() => console.log('all done'));
  asyncLoadJS('a.js').then(() => console.log('all done'));
 * @param {Array|String} dependencies
 * @returns
 */
function asyncLoadJs(dependencies) {
  if (Array.isArray(dependencies)) {
    return Promise.all(dependencies.map(loadJs));
  } else {
    return loadJs(dependencies);
  }
}

function loadJs(src) {
  const script = document.createElement('script');
  script.src = src;

  // 返回一个独立的promise
  return new Promise((resolve, reject) => {
    var done = false;

    script.onload = script.onreadystatechange = () => {
      if (
        !done &&
        (!script.readyState ||
          script.readyState === 'loaded' ||
          script.readyState === 'complete')
      ) {
        done = true;

        // 避免内存泄漏
        script.onload = script.onreadystatechange = null;
        resolve(script);
      }
    };

    script.onerror = reject;
    document.getElementsByTagName('head')[0].appendChild(script);
  });
}

export default asyncLoadJs;
